import React, { useCallback } from 'react';
import CustomButton from '../../features/customButton/ui/main/CustomButton';

const InfoButton = React.forwardRef(function InfoButton({ onClick }, ref) {
  const click = useCallback(
    (e) => {
      onClick?.(e);
    },
    [onClick],
  );

  return (
    <CustomButton
      icon={'buttons/info'}
      className={'custom-button_icon custom-button_transparent w-modal__info-button'}
      onClick={click}
    />
  );
});
export default InfoButton;
InfoButton.propTypes = {};
